var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Interfaces = OCS.Viewer.Interfaces || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
// Requires: LayerGroupLayerManipulation, OCS.Viewer.Interfaces.LayerGroupTime, OCS.Viewer.Interfaces.LayerGroupRequest
OCS.Viewer.Functions.define_layer_group_nids_interface = function () {
    OCS.Viewer.Interfaces.LayerGroupnids = {
        init_nids_events: function () {
            this.addEvent('init', this.on_init_nids.bind(this));
        },
        on_init_nids: function () {
            var dateObj = this.get_map_datetime_obj();
            var earliest_epoch_ts = dateObj.get_start_epoch_time();
            var latest_epoch_ts = dateObj.get_end_epoch_time();
            var start, req_options, stale;

            //radar
            req_options = this.get_request_options();
            var variable = this.get_variables();
            start = this.get_latest_timestamp_epoch();
            if (!start) {
                start = earliest_epoch_ts;
            }
            stale = this.get_stale_threshold();
            req_options.date_request = true;
            var dataset = this.get_dataset_obj();
            req_options.metadata.url = dataset.get_query_url({start: dateObj.get_utc_long_string(start - (stale / 2)), end: dateObj.get_utc_long_string(latest_epoch_ts), product: variable[0].parm, site: variable[0].site});
            var radar_request = new OCS.Viewer.Classes.DataMngrDataRequest(req_options);
            radar_request.addEvent('success', this.on_radar_dates_retrieval.bind(this));
            radar_request.activate_request();
            this.subscribe();
            this.fireEvent('show_current_layer', null, 1);

            if (this.init_time_events) {
                this.init_time_events();
            }
            if (this.show_current_frame_method) {
                this.show_current_frame_method();
            }
        },
        on_radar_dates_retrieval: function (request) {
            var data = request.get_data();
            if (data && data.json) {
                request.destroy();
                var dateObj = this.get_map_datetime_obj();
                var dates = data.json();
                if (dates.dates) {
                    /* Check if we have data at the site and add a banner if we don't. */
                    if (dates.dates.length < 1) {
                        var vars = this.get_variables();
                        this.fireEvent(OCS.Viewer.Config.events.PRODUCT_DOWN, "We were unable to fetch the " + vars[0].units + " radar at this time.");
                    } else {
                        var dates_array = dates.dates.reverse();
                        Object.each(dates_array, function (date, index) {
                            date = date.replace(/-/g, '/');
                            this.get_layer_source(dateObj.date_long_string_to_epoch(date));
                        }.bind(this));
                    }
                }
            }
        }
    };
};
OCS.Viewer.Functions.define_layer_group_nids_interface();